import React, { Component, Fragment } from "react";

import { connect } from "react-redux";
import { auth, database, onMessageListener, isSpported } from "../../Firebase/firebase";
import MainToolBar from "../../Component/Navigation/MainToolBar/MainToolBar";
import Authentication from "../Authentication/Authentication";
import * as actionCreators from "../../Store/actions/index";
import Spinner from "../../Component/UI/spinner/Spinner";
import DealerCard from "../../Component/Chat/DealerCard";
import Chatpage from "../../Component/Chat/Chat";
import SendMessage from "../../Component/Chat/SendMessage";

class Chats extends Component {
    state = {
        runCleaner: true,
        chatId: null,
        //reciver info
        dealerId: null,// recvierID
        recivertoken: null,
        //Search:
        searchInput: '',
        //Auth:
        showAuth: false,
        authMode: 'signIn'
    }

    componentDidMount() {
        const query = new URLSearchParams(this.props.location.search);

        let chatId, dealerId, recivertoken,
            token = localStorage.getItem('idToken'),
            senderId = localStorage.getItem('uid');

        for (let param of query.entries()) {
            if (param[0] === 'with') {
                dealerId = param[1]
            } else if (param[0] === 'chat') {
                chatId = param[1]
            }
        }

        this.setState({ chatId: chatId, dealerId: dealerId });

        if (!token) {
            const fireUser = auth.currentUser
            if (fireUser) {
                fireUser.getIdToken(true)
                    .then(responseToken => {
                        token = responseToken
                    })
                    .catch(error => console.log(error))
            }
            else {
                console.log(fireUser)
            }
        }
        this.props.onGetAllUsers(token);
        this.props.onGetChat(token, chatId, dealerId, senderId);

        //Reciver:
        const tokenRetriver = database.ref('recivers/' + dealerId + '/token');
        tokenRetriver.on('value', snapshot => {
            recivertoken = snapshot.val()
            this.setState({ recivertoken: recivertoken });
        })
        if (!isSpported()) {
            
            this.dataPolling = setInterval(() => {
                this.props.onGetChat(token, this.state.chatId, dealerId, senderId, true);
            }, 4000)
        }

    }

    runCleanerHandler = () => {
        this.setState({ runCleaner: false })
    }

    showNewCreatedMessageHandler = (message) => {
        const updatedChats = { ...this.props.chat },
            updatedChatMessages = [...updatedChats.chat_messages],
            newCreatedMessage = {
                id: 'newCreatedMess' + toString(Math.random()),
                message: message,
                created_at: new Date(),
                receiver_id: +this.state.dealerId,
                lightRight: true
            };
        updatedChatMessages.push(newCreatedMessage);
        updatedChats.chat_messages = updatedChatMessages;
        this.props.onSuccessGetChat({ data: updatedChats })
    }



    componentDidUpdate() {
        const token = localStorage.getItem('idToken');
        const senderId = localStorage.getItem('uid');

        if (isSpported()) {
            onMessageListener()
                .then((payload) => {
                    this.props.onGetChat(token, this.state.chatId, this.state.dealerId, senderId, true);
                })
                .catch((err) => {
                    console.log(err);
                });
        }

    }

    componentWillUnmount() {
        clearInterval(this.dataPolling)
    }

    // Search

    searchInputHandler = (value) => {
        this.setState({
            searchInput: value
        })
    }

    reLoadSearchPageHandler = () => {
        //  console.log('tes')
    }

    // Authebtication :

    showAuthHandler = (mode, kepShowing) => {
        if (kepShowing) {
            this.setState({ showAuth: true })
        } else {
            this.setState((prevState) => {
                return { showAuth: !prevState.showAuth }
            })
        }
        if (mode === 'signUp') {
            this.setState({
                authMode: 'signUp'
            })
        }
        else if (mode === 'signIn') {
            this.setState({
                authMode: 'signIn'
            })
        }
        else if (mode === 'passwordReset') {
            this.setState({
                authMode: 'passwordReset'
            })
        }
        else if (mode === 'verifyEmail') {
            this.setState({
                authMode: 'verifyEmail'
            })
        }
    }

    render() {
        let user = null,
            dealerCard = <Spinner />;
        if (this.props.allUsers) {
            user = this.props.allUsers.filter(u => u.id === +this.state.dealerId)[0];
            dealerCard = <DealerCard dealer={user} />;
        }
        return (
            <Fragment>
                {this.state.showAuth ?
                    <Authentication
                        showAuth={this.state.showAuth}
                        showAuthHandler={this.showAuthHandler}
                        authMode={this.state.authMode} />
                    :
                    null}
                <MainToolBar searchInput={(value) => { this.searchInputHandler(value) }}
                    searchInputValue={this.state.searchInput}
                    props={{ ...this.props }}
                    reLoadSearchPage={this.reLoadSearchPageHandler}
                    showAuthHandler={this.showAuthHandler}
                    user={this.props.user}
                />
                {dealerCard}
                {this.props.chatLoading ?
                    <div style={{
                        backgroundColor: '#fbfbfb',
                        minHeight: '59vh',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center'
                    }}>

                        <Spinner />
                    </div>
                    :
                    null}
                {this.props.chat ?
                    <Chatpage
                        chat={this.props.chat}
                        reciverId={this.state.dealerId}
                        cleanChat={this.props.onCleanChat}
                        runCleaner={this.state.runCleaner}
                        runCleanerHandler={this.runCleanerHandler} />
                    :
                    null
                }
                <SendMessage
                    reciverId={this.state.dealerId}
                    chatId={this.state.chatId}
                    sendMessage={this.props.onSendMessage}
                    runCleaner={this.state.runCleaner}
                    runCleanerHandler={this.runCleanerHandler}
                    showNewCreatedMessageHandler={this.showNewCreatedMessageHandler}
                    recvierToken={this.state.recivertoken}
                />
            </Fragment>
        );
    }
}

const mapStateToProps = state => {
    return {
        chatLoading: state.Chat.chatLoading,
        chat: state.Chat.chat,
        //all dealer:
        allUsers: state.Messages.allUsers,
        //auth
        user: state.Auth.user
    }
};

const mapDispatchToProps = dispatch => {
    return {
        onGetChat: (token, chatId, receiverId, senderId, skipLoading) => { dispatch(actionCreators.getChat(token, chatId, receiverId, senderId, skipLoading)) },
        onSuccessGetChat: (data) => { dispatch(actionCreators.successGetChat(data)) },
        onGetAllUsers: (token) => { dispatch(actionCreators.getAllUsers(token)) },
        onCleanChat: (shouldClaen) => { dispatch(actionCreators.cleanChat(shouldClaen)) },
        onSendMessage: (token, message, receiverId, senderId, chatId, recvierToken) => { dispatch(actionCreators.createMessage(token, message, receiverId, senderId, chatId, recvierToken)) }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Chats)